/** 工具接口。 */
import { http } from '@/utils/request'
import type { Tool, ToolCreate, ToolUpdate } from '@/types/tool'
import type { ApiMessage, CreateResult } from '@/types/common'

export function getTools(params?: {
  category_id?: number
  include_inactive?: boolean
}): Promise<Tool[]> {
  return http.get<Tool[]>('/tools', { params })
}

export function getTool(id: number): Promise<Tool> {
  return http.get<Tool>(`/tools/${id}`)
}

export function createTool(payload: ToolCreate): Promise<CreateResult> {
  return http.post<CreateResult>('/tools', payload)
}

export function updateTool(id: number, payload: ToolUpdate): Promise<ApiMessage> {
  return http.put<ApiMessage>(`/tools/${id}`, payload)
}

export function deleteTool(id: number): Promise<ApiMessage> {
  return http.delete<ApiMessage>(`/tools/${id}`)
}

export function updateToolsOrder(ids: number[]): Promise<ApiMessage> {
  return http.put<ApiMessage>('/tools/sort', { ids })
}
